import {
  SET_PHOTOSWIPE_OPEN,
  SET_PHOTOSWIPE_INDEX,
  SET_PHOTOSWIPE_MOMENT_ID,
  SET_PHOTOSWIPE_ITEMS,
  ADD_PHOTOSWIPE_ITEMS,
  CLEAR_PHOTOSWIPE_ITEMS
} from 'shared/actions/types';

import {
  trackEvent
} from 'shared/services/Analytics';

export const setPhotoSwipeOpen = isOpen => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_OPEN,
    payload: isOpen
  });

  window.disableStoryDrag = isOpen;

  return Promise.resolve();
}

export const setPhotoSwipeIndex = index => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_INDEX,
    payload: index
  });

  return Promise.resolve();
}

export const setPhotoSwipeMomentId = (momentId, trackOpts = {}) => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_MOMENT_ID,
    payload: momentId
  });

  if (trackOpts.user) {
    trackEvent('Moment.Open', {
      userId: trackOpts.user.id,
      storyId: trackOpts.story.id,
      storyName: trackOpts.story.name,
      momentId: momentId,
      'Portal.Account': trackOpts.user.account_id,
    });
  }

  return Promise.resolve();
}

export const setPhotoSwipeItems = (storyId, items) => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_ITEMS,
    payload: { storyId, items }
  });

  return Promise.resolve();
}

export const addPhotoSwipeItems = (storyId, items) => dispatch => {
  dispatch({
    type: ADD_PHOTOSWIPE_ITEMS,
    payload: { storyId, items }
  });

  return Promise.resolve();
}

export const clearPhotoSwipeItems = storyId => dispatch => {
  dispatch({
    type: SET_PHOTOSWIPE_ITEMS,
    payload: { storyId }
  });

  return Promise.resolve();
}
